import { SeverityLevel } from '@microsoft/applicationinsights-web';

export const initializeFeatureFlags = async (store) => {
    await store.dispatch('App/loadFeatureFlags', {
        onFeatureFlagParseError: (featureFlag) => {
            this.appInsights?.trackTrace(
                `
                        Error during parsing ${featureFlag.name} flag (value "${featureFlag.value}")
                        `,
                SeverityLevel.Error
            );
        },
    });
};
